<template>
    <div>
        <cardWrapper>
            <div class="row">
                <div class=" col-md-6  my-auto text-center order-lg-2">
                     <img  src="/images/pages/academy_bg.png" style=" max-width: 300px; height: auto;">
                </div>
                <div class="col-md-6 order-lg-1">
                   
                    <h3 class="mb-2 mt-3 text-center">
                        {{$t('message.academy_tytle')}}
                    </h3>
                    <div class="row mb-3  ">
                        <div class="col-6 text-center"><router-link class="btn btn-outline-success"  :to="{ path:'/acad_webinars'}">{{$t('message.webinars')}}</router-link> </div>   
                        <div class="col-6 text-center"><router-link class="btn btn-outline-danger"  :to="{ path:'/acad_library'}">{{$t('message.library')}}</router-link> </div>    
                        <div class="text-left  mt-3  ">
                             {{$t('message.academy_text')}}
                        </div>
                    </div>
                </div>
               
            </div>
            
        </cardWrapper>
    </div>  

</template>

<script>
import cardWrapper from '@/components/cardWrapper'; 
export default {
  name: 'academy',
  data () {
        return {
        }
  },
  methods:{},
  components:{
    cardWrapper
  },
  mounted() {},
}

</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }
    .faq-card{
            min-height: 50px;
            border: 2px solid #727E8C;
            padding: 20px;
            text-align: center;
            cursor: pointer;
            
    }
    .faq-card.active{
            min-height: 50px;
            color:#5A8DEE;
            font-weight: bold;
            border: 2px solid #5A8DEE;
            
            
    }
</style>

	